import { render, staticRenderFns } from "./admin_header.vue?vue&type=template&id=0f9997bc&scoped=true&"
import script from "./admin_header.vue?vue&type=script&lang=js&"
export * from "./admin_header.vue?vue&type=script&lang=js&"
import style0 from "./admin_header.vue?vue&type=style&index=0&id=0f9997bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9997bc",
  null
  
)

export default component.exports